import * as general from "./general";
/**
 * Creates an instance of
 * axios that always uses the eatup api
 * base route
 */
export const api = {
  general
};
